/* eslint-disable import/no-unresolved */
import React from 'react';

import RightModalLayout from '../../../../../../../../layouts/Modal/RightModalLayout';
import ToggleSwitchMC from '../../../../../../../../components/ToggleSwitchMC';

const PurchaseIntentionToolView = ({
  t,
  title,
  footerSubmitLabel,
  handleBack,
  handleConfirmPurchaseIntention,
  purchaseIntentionAiDisabled,
  setPurchaseIntentionAiDisabled
}) => (
  <RightModalLayout
    closeAction={handleBack}
    title={title || t('tools.purchase_intention_title')}
    showBackButton
    submitLabel={footerSubmitLabel}
    submitAction={handleConfirmPurchaseIntention}
    cancelLabel={t('Common:actions.cancel')}
    cancelAction={handleBack}
    footerVariant="VERTICAL"
  >
    <div className="tw-flex tw-flex-col tw-gap-6">
      <div>
        <div className="tw-font-bold tw-text-gray-900 tw-text-sm tw-mb-1">
          {title || t('tools.purchase_intention_title')}
        </div>
        <div className="tw-text-gray-600 tw-text-xs">
          {t('config.disable_ai_agent.section_description')}
        </div>
      </div>
      <ToggleSwitchMC
        isOn={purchaseIntentionAiDisabled}
        handleToggle={setPurchaseIntentionAiDisabled}
        label={t('config.disable_ai_agent.toggle_label')}
        labelClassName="!tw-font-semibold"
        size="medium"
      />
    </div>
  </RightModalLayout>
);

export default PurchaseIntentionToolView;
